module.exports = __webpack_public_path__ + "images/shard-navy.svg";